import isSameDay from 'date-fns/is_same_day';
const isIntervalEdge = function (day, intervals) {
  let edge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'start';
  return intervals.some(interval => isSameDay(day, interval[edge]));
};
export default isIntervalEdge;
//# sourceMappingURL=isIntervalEdge.js.map